import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { useFormContext } from "react-hook-form-mui";
import NumberSpinnerField from "../fields/NumberSpinnerField";
export default function Amount({ min, max, required, label, value, setter, object }) {
    const theme = useTheme();
    const isLarge = useMediaQuery(theme.breakpoints.up('sm'));
    const { setValue } = useFormContext();
    useEffect(() => {
        if (value && !required) {
            if (max && max > 0 && value > max) {
                value = max;
            }
            if (setter)
                setter(value);
            setValue(object ? `amount-${object.id}` : 'amount', value);
        }
    }, [value]);
    const onChange = (value) => {
        if (setter)
            setter(value);
    };
    const onChangeQuantity = (value, name) => {
        if (!max || (max && max > 0 && value <= max)) {
            setValue(object ? `amount-${object.id}` : 'amount', value);
            if (setter)
                setter(value);
        }
    };
    const options = [];
    for (let i = (min ? min : 1); i < (max ? max + 1 : 100); i++) {
        options.push({ id: i, label: i.toString() });
    }
    return (_jsx(_Fragment, { children: options.length > 0 && (_jsx(NumberSpinnerField, { max: max && max > 0 ? max : 99, onChange: onChangeQuantity, name: object ? `amount-${object.id}` : 'amount', defaultValue: value !== null && value !== void 0 ? value : 1 })) }));
}
